module.exports = __webpack_public_path__ + "static/media/pres2.e87aed6d.png";